module.exports = __webpack_public_path__ + "img/bodybuilding.1b92f115.png";